import { Api } from './Api'

const preloadProducts = sessionStorage.getItem('preloadProducts')
const preloadProductsObj = preloadProducts ? JSON.parse(preloadProducts) : {}
const category = Object.keys(preloadProductsObj)

const promptStr = `Find list of all the objects which is belongs to this category ${category} in this image attached. Please reply in JSON format should including: object_name and object_location [x, y, width, height] in pure JSON format. (Maximum length is 10)`

export async function generatePayload (base64Image:string) {
  base64Image = base64Image.split(',')[1]
  const res:{base64Image:string} = await Api.post('/process-image', {
    base64Image
  })
  base64Image = res.base64Image
  const payload = {
    contents: [
      {
        parts: [
          {
            inlineData: {
              mimeType: 'image/png',
              data: base64Image
            }
          },
          {
            text: promptStr
          }
        ]
      }
    ]
  }
  return payload
}

export function sanitizeTripleBacktickBlock (text:string):string {
  const match = text.match(/\[\s*{[\s\S]*?}\s*]/)
  return Array.isArray(match) ? match[0] : '[]'
}

export const generateContentFromGemini = async (
  { base64Image }: { base64Image: string}) => {
  const data = await generatePayload(base64Image)
  try {
    const response: {success:boolean, data: string} = await Api.post('/video/generate', data)

    if (response?.data && response?.success) {
      const rawText = JSON.parse(response?.data)?.candidates?.[0]?.content?.parts?.[0]?.text
      return JSON.parse(sanitizeTripleBacktickBlock(rawText))
    }

    return {}
  } catch (error) {
    console.error('❌ Error calling Gemini:', error.response?.data || error.message)
    return {}
  }
}
